"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dublicateEqualityFn = exports.createContextSelectorHook = void 0;

var react_1 = require("react");

var hooks_1 = require("../hooks");

var equality_functions_1 = require("../equality-functions");

var EMPTY_DEPS = ["__$$EMPTY:%$W,w_&te-nw~[rzSETQK5{CB9V?F&+8n_m\nFZB?:fW]Y2QG$$__"];

var defaultTransformer = function defaultTransformer() {
  var x = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    x[_i] = arguments[_i];
  }

  return x;
};

exports.createContextSelectorHook = function (context, defaultProviderId, useGettingDefaultValue) {
  var defaultEqualityFn = globallyDefaultCompare;

  function useContextValue() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var _a = getArgs(args, defaultEqualityFn),
        fn = _a[0],
        areDataEqual = _a[1],
        deps = _a[2],
        passedLabel = _a[3];

    var label = react_1.useState(passedLabel)[0];
    var fnRef = react_1.useRef(fn);
    fnRef.current = fn;
    var areDataEqualRef = react_1.useRef(areDataEqual);
    areDataEqualRef.current = areDataEqual;
    var latestSubscriptionCallbackErrorRef = react_1.useRef();
    var forceUpdate = hooks_1.useForceUpdate();

    var _b = react_1.useContext(context),
        getLatestValue = _b.getLatestValue,
        asyncReverseOrderSubscribe = _b.asyncReverseOrderSubscribe,
        id = _b.id;

    if (id === defaultProviderId) {
      useGettingDefaultValue();
    }

    var transformedInitialValue = react_1.useState(function () {
      return fn.apply(void 0, getLatestValue());
    })[0];
    var transformedValueRef = react_1.useRef(transformedInitialValue);
    var selectedState;

    try {
      if (latestSubscriptionCallbackErrorRef.current) {
        selectedState = fn.apply(void 0, getLatestValue());
      } else {
        selectedState = transformedValueRef.current;
      }
    } catch (err) {
      if (latestSubscriptionCallbackErrorRef.current) {
        err.message += "\nLabel: " + label + "\n";
        err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackErrorRef.current.stack + "\n\n";
      }

      throw err;
    }

    react_1.useLayoutEffect(function () {
      transformedValueRef.current = selectedState;
      latestSubscriptionCallbackErrorRef.current = undefined;
    });
    react_1.useLayoutEffect(function () {
      var isCancelled = false;

      var cb = function cb(delay) {
        var data = [];

        for (var _i = 1; _i < arguments.length; _i++) {
          data[_i - 1] = arguments[_i];
        }

        if (isCancelled) return;
        var time = 0;

        try {
          var value = fnRef.current.apply(fnRef, data);

          if (areDataEqualRef.current(transformedValueRef.current, value)) {
            return;
          }

          transformedValueRef.current = value;
        } catch (err) {
          // we ignore all errors here, since when the component
          // is re-rendered, the selectors are called again, and
          // will throw again
          latestSubscriptionCallbackErrorRef.current = err;
          time = 0;
        }

        if (delay) {
          setTimeout(function () {
            if (isCancelled) return;
            forceUpdate();
          }, time);
        } else {
          forceUpdate();
        }
      };

      var unsubscribe = asyncReverseOrderSubscribe(function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return cb.apply(void 0, __spreadArrays([true], args));
      }, label);
      setTimeout(function () {
        if (isCancelled) return;
        cb.apply(void 0, __spreadArrays([false], getLatestValue()));
      }, 0);
      return function () {
        isCancelled = true;
        unsubscribe();
      };
    }, [label]);
    useCustomMemoHook(function () {
      var value = fnRef.current.apply(fnRef, getLatestValue());
      if (areDataEqual(selectedState, value)) return;
      selectedState = value;
    }, deps);
    return selectedState;
  }

  useContextValue.extendHook = function (fn) {
    var hook = exports.createContextSelectorHook(context, defaultProviderId, useGettingDefaultValue);

    var finalHook = function finalHook(trans) {
      var args = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }

      if (!trans) {
        var _a = hook.getEqualityFnInfo(),
            eqFn = _a.fn,
            isDefaultFn = _a.isDefaultFn;

        return hook(function () {
          var rootData = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            rootData[_i] = arguments[_i];
          }

          return fn.apply(void 0, rootData);
        }, isDefaultFn ? equality_functions_1.depsShallowEquality : eqFn, []);
      }

      return hook.apply(void 0, __spreadArrays([function () {
        var rootData = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          rootData[_i] = arguments[_i];
        }

        return trans.apply(void 0, fn.apply(void 0, rootData));
      }], args));
    };

    finalHook.setEqualityFn = hook.setEqualityFn;

    finalHook.extendHook = function (someFn) {
      return hook.extendHook(function () {
        var data = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          data[_i] = arguments[_i];
        }

        return someFn.apply(void 0, fn.apply(void 0, data));
      });
    };
    /* const defEq = (...args) => defaultEqualityFn(...args as [any, any]);
    defEq.___isSubscriberDefaultFn = () => {
        return isDefaultEquality(defaultEqualityFn)
    } */


    var copiedEquality = exports.dublicateEqualityFn(useContextValue);
    finalHook.setEqualityFn(copiedEquality);

    finalHook.getEqualityFnInfo = function () {
      return {
        fn: copiedEquality,
        isDefaultFn: isDefaultEquality(copiedEquality)
      };
    };

    return finalHook;
  };

  useContextValue.setEqualityFn = function (equalityFn) {
    defaultEqualityFn = equalityFn;
  };

  useContextValue.getEqualityFnInfo = function () {
    return {
      fn: defaultEqualityFn,
      isDefaultFn: isDefaultEquality(defaultEqualityFn)
    };
  };

  return useContextValue;
};

exports.dublicateEqualityFn = function (useSelector) {
  var selectorValueEqualityFn = function selectorValueEqualityFn(prev, next) {
    return useSelector.getEqualityFnInfo().fn(prev, next);
  };

  selectorValueEqualityFn.___isSubscriberDefaultFn = function () {
    return useSelector.getEqualityFnInfo().isDefaultFn;
  };

  return selectorValueEqualityFn;
};

var shallowCompare = function shallowCompare(prev, next) {
  return prev === next;
};

shallowCompare.___isSubscriberDefaultFn = function () {
  return true;
};

var isDefaultEquality = function isDefaultEquality(fn) {
  if (typeof fn !== "function") return false;
  if (typeof fn.___isSubscriberDefaultFn !== "function") return false;
  return fn.___isSubscriberDefaultFn();
};

var globallyDefaultCompare = shallowCompare;
var useCustomMemoHook = hooks_1.createMemoHook(function (oldDeps, newDeps) {
  if (oldDeps === EMPTY_DEPS || newDeps === EMPTY_DEPS) return false;
  return equality_functions_1.depsShallowEquality(oldDeps, newDeps);
});

var getArgs = function getArgs(args, defaultEqualityFn) {
  if (isDefaultEquality(defaultEqualityFn)) {
    defaultEqualityFn = undefined;
  }

  var label = undefined;

  if (typeof args[args.length - 1] === "string") {
    label = args[args.length - 1];
    args = args.slice(0, args.length - 1);
  }

  var areDataEqual = defaultEqualityFn || shallowCompare;
  var deps = null;
  var fn = args[0] ? args[0] : defaultTransformer;

  if (args.length > 2) {
    if (args[1]) areDataEqual = args[1];
    deps = args[2];
  } else if (args[1] !== undefined) {
    if (Array.isArray(args[1]) || args[1] === null) {
      deps = args[1];
    } else if (typeof args[1] === "function") {
      areDataEqual = args[1];
    }
  }

  if (!args[0]) {
    areDataEqual = defaultEqualityFn || equality_functions_1.depsShallowEquality;
  }

  return [fn, areDataEqual, deps || EMPTY_DEPS, label];
};